import { StatusSchema } from '../../../services/StatusService/StatusService.schemas';

export const IMAGE_SIZE = 180;

export const IMAGES_GAP = 'space-1000';

export const STATUSES = StatusSchema.options.filter(
  (status) => status !== 'Member' && status !== 'Vip',
);
